import service from "@/store/services/weekly-reports-report-service";

export const state = () => ({
  reportData: [],
  chartData: {
    evolutionOverTime: [],
  },
  meta: {},
  loading: false,
  chartLoading: false,
});

export const mutations = {
  SET_REPORT_DATA: (state, data) => {
    state.reportData = data;
  },
  SET_CHART_DATA: (state, data) => {
    state.chartData = data;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_LOADING: (state, loading) => {
    state.loading = loading;
  },
  SET_CHART_LOADING: (state, loading) => {
    state.chartLoading = loading;
  },
};

export const actions = {
  fetchReport({ commit }, params) {
    commit("SET_LOADING", true);
    return service
      .getReport(params)
      .then(({ data, meta }) => {
        commit("SET_REPORT_DATA", data);
        commit("SET_META", meta);
        return { data, meta };
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },

  fetchChartData({ commit }, params) {
    commit("SET_CHART_LOADING", true);
    return service
      .getChartData(params)
      .then((data) => {
        commit("SET_CHART_DATA", data);
        return data;
      })
      .finally(() => {
        commit("SET_CHART_LOADING", false);
      });
  },
};

const getters = {
  reportData: (state) => state.reportData,
  chartData: (state) => state.chartData,
  meta: (state) => state.meta,
  loading: (state) => state.loading,
  chartLoading: (state) => state.chartLoading,
  totalPages: (state) =>
    state.meta?.page?.last_page || Math.ceil((state.meta?.page?.total || 0) / (state.meta?.page?.per_page || 25)),
};

const weeklyReportsReport = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default weeklyReportsReport;
